














export default {
    name: "PageLoadingSpinner",
    props: {
        isInitialLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        isRefreshLoading: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        isLoading: function() {
            return this.isInitialLoading || this.isRefreshLoading
        },
        loadingProgressClasses: function() {
            return {
                "loading-progress-initial": this.isInitialLoading,
                "loading-progress-refresh": !this.isInitialLoading,
            }
        }
    },
    mounted() {
        // suppression de l'auto scrolling
        // si la page est ancrée en bas lors du loading
        // la page peut rester ancrée en bas après la disparition du loader
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    }
}

